import { Link, useLocation } from 'react-router-dom';
import { useSetAtom } from 'jotai';
import AsyncButton from '@wojtekmaj/react-async-button';
import T, { useTranslation } from '@wojtekmaj/react-t';

import { toast } from '@rewardopl/react-toast';

import Button from '@rewardopl/react-ui/button';
import InputField from '@rewardopl/react-ui/input_field';

import { post } from '@rewardopl/utils/network';

import { ButtonWrapper, Form } from './form.styles';

import { maybeCurrentUserState } from '../../../../store';

import type { User } from '@rewardopl/types';

const pendingConfig = {
  disabled: true,
};

export default function LoginEmailForm() {
  const location = useLocation();
  const setCurrentUser = useSetAtom(maybeCurrentUserState);
  const loginErrorString = useTranslation('Failed to log in');
  const invalidUsernameOrPasswordString = useTranslation('Invalid username or password');

  const { email } = (location.state || {}) as { email?: string };

  const action = '/api/users/login';

  async function onClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    event.preventDefault();

    const submitButton = event.currentTarget;
    const form = submitButton.form;

    if (!form || !form.reportValidity()) {
      return;
    }

    try {
      const user = (await post(action, {
        body: new FormData(form),
      })) as User;

      setCurrentUser(user);
    } catch (error) {
      if (error instanceof Error && error.message === 'Invalid username or password') {
        toast.error(invalidUsernameOrPasswordString);
        return;
      }

      toast.error(loginErrorString);
    }
  }

  return (
    <Form action={action} method="POST">
      <InputField
        autoComplete="username"
        label="Email"
        maxLength={320}
        name="email"
        placeholder="email@example.com"
        type="email"
        value={email}
      />
      <InputField
        autoComplete="current-password"
        label="Password"
        name="password"
        placeholder="••••••••"
        type="password"
      />
      <ButtonWrapper>
        <AsyncButton
          as={Button}
          className="primary"
          onClick={onClick}
          pendingConfig={pendingConfig}
          type="submit"
        >
          <T>Login</T>
        </AsyncButton>
      </ButtonWrapper>
      <Link to="/password_reset">
        <T>Forgot password?</T>
      </Link>
    </Form>
  );
}
